import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import axios from "axios";

import "bootstrap/dist/css/bootstrap.min.css";
import { BaseURL } from "./constants/enum/baseURL.emum";
// import "css-file-icons/build/css-file-icons.css";

// axios.defaults.baseURL = "https://apitqf.fte.rmuti.ac.th/api";
/////////   ^^^^^^  สลับไปมากรณีทดสอบ Local กับ server  vvvvvvv      /////////
// axios.defaults.baseURL = "http://localhost:5500/api";
axios.defaults.baseURL = BaseURL.BASE_URL;

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
